import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

// A 403 (company-level auth gap) must degrade to the empty state — never trigger
// the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_SUMMARY_ACTION_TYPE = createNamedActions('commandCenterSummary', {
  SET_SUMMARY: 'SET_SUMMARY',
});

export const getCommandCenterSummaryAction = catchAsyncActionError(() => async dispatch => {
  const fetchSafe = async () => {
    try {
      const { data } = await commandCenterLoansApi.getSummary({ config: SKIP_FORBIDDEN_CONFIG });

      return data ?? null;
    } catch {
      return null;
    }
  };

  try {
    const data = await fetchSafe();

    dispatch({
      type: COMMAND_CENTER_SUMMARY_ACTION_TYPE.SET_SUMMARY,
      payload: data,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403
    // degrades to null — otherwise the zone skeleton never clears.
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.SUMMARY));
  }
});
